// extracted by mini-css-extract-plugin
export default {"usersTable":"BrowserUsedByUsers_usersTable__B4gen"};